// Razorpay script loader
let isRazorpayLoaded = false;
let razorpayCallbacks = [];

const loadRazorpay = () => {
  return new Promise((resolve, reject) => {
    if (window.Razorpay) {
      resolve();
      return;
    }

    if (isRazorpayLoaded) {
      razorpayCallbacks.push(resolve);
      return;
    }

    isRazorpayLoaded = true;
    const script = document.createElement('script');
    script.src = 'https://checkout.razorpay.com/v1/checkout.js';
    script.async = true;

    script.onload = () => {
      resolve();
      razorpayCallbacks.forEach(cb => cb());
      razorpayCallbacks = [];
    };

    script.onerror = () => {
      const error = new Error('Razorpay script failed to load');
      reject(error);
      razorpayCallbacks.forEach(cb => cb(error));
      razorpayCallbacks = [];
      isRazorpayLoaded = false;
    };

    document.head.appendChild(script);
  });
};

export default loadRazorpay;

